import { type FC, type ReactNode, useLayoutEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { SUPPORTED_LANGUAGES } from "@/i18n/i18n";
import i18n from "i18next";

type Lang = (typeof SUPPORTED_LANGUAGES)[number];

const DEFAULT_LANG: Lang = "pl";

export const LanguageProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const [lang, setLang] = useState<Lang>(DEFAULT_LANG);

  const initialized = useRef(false);

  useLayoutEffect(() => {
    if (!initialized.current) {
      initialized.current = true;

      const langParam = searchParams.get("lang");
      const resolvedLang: Lang = SUPPORTED_LANGUAGES.includes(langParam as Lang)
        ? (langParam as Lang)
        : DEFAULT_LANG;

      setLang(resolvedLang);
    }
  }, [searchParams]);

  useLayoutEffect(() => {
    void i18n.changeLanguage(lang);
  }, [lang]);

  return <>{children}</>;
};
